import type { AnyAction, Reducer } from 'redux';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import { Actions } from '../actionTypes/actionTypes';
import { getInitialPdfShareLinkState } from './pdfShareLinkInitialState';
import type { PdfShareLinkState } from './types';

export const pdfShareLink: Reducer<PdfShareLinkState> = (
    state: PdfShareLinkState = getInitialPdfShareLinkState(),
    action: AnyAction
) => {
    switch (action.type) {
        case Actions.FETCH_PDF_SHARE_LINK_REQUEST: {
            return { ...state, requestStatus: ApiRequestStatus.Loading, shortUrl: undefined };
        }
        case Actions.FETCH_PDF_SHARE_LINK_SUCCESS: {
            return {
                ...state,
                requestStatus: ApiRequestStatus.Success,
                shortUrl: action.payload?.shortUrl,
                cachedForVersion: action.meta?.dealXgVersion
            };
        }
        case Actions.FETCH_PDF_SHARE_LINK_FAILURE: {
            return { ...state, requestStatus: ApiRequestStatus.Error, shortUrl: undefined, cachedForVersion: undefined };
        }
        default:
            return state;
    }
};
